// Client-side quick phrases for work order timeline notes (UI only).
export const WORK_ORDER_NOTE_TEMPLATES = [
  'Work Order Received',
  'Work Order Assigned',
  'Tech is Scheduled to be onsite',
  'Tech is on the way',
  'Tech is onsite',
  'New ETA Updated',
  'Waiting on parts. ETA remains the same',
  'Waiting on parts. New ETA updated',
  'Delay from the supplier. New ETA Updated',
  'Working on a new ETA',
  'Awaiting Quote Approval',
];
